import TablaProducto from './TablaProducto';
export default TablaProducto;